import styled from "styled-components"

const LeaveCommentContainer=styled.div`
width: 65%;
margin: auto;
margin-top: 100px;
margin-bottom: 50px;
.textarea{
  width: 100%;
  margin: auto;
  background: #fff9e6;
    border: 1px solid #EFEFEF;
    border-radius: 20px;    
    outline: none;
    height: 50px;
    padding: 20px;
    margin-bottom: 8px;
    font-family: Proxima Nova;
    font-size: 14px;
    line-height: 17px;
    color: #5C5C5C;
    resize: none;
  }
`

export default LeaveCommentContainer